/**
 * Logger utilitaire qui se désactive automatiquement en production.
 *
 * Utilisation:
 * ```typescript
 * import { logger } from '@/utils/logger';
 *
 * logger.log('Message info');
 * logger.warn('Message avertissement');
 * logger.error('Message erreur');
 * logger.debug('Message debug détaillé');
 * ```
 *
 * En production (NODE_ENV=production), seuls les .error() sont affichés.
 * En développement, tous les logs sont affichés.
 */

const isDevelopment = process.env.NODE_ENV !== 'production';
const isTest = process.env.NODE_ENV === 'test';

export const logger = {
  /**
   * Log d'information (désactivé en production)
   */
  log: (...args: any[]) => {
    if (isDevelopment && !isTest) {
      console.log(...args);
    }
  },

  /**
   * Log d'avertissement (désactivé en production)
   */
  warn: (...args: any[]) => {
    if (isDevelopment && !isTest) {
      console.warn(...args);
    }
  },

  /**
   * Log d'erreur (actif en production pour debugging)
   */
  error: (...args: any[]) => {
    if (!isTest) {
      console.error(...args);
    }
  },

  /**
   * Log de debug (désactivé en production)
   */
  debug: (...args: any[]) => {
    if (isDevelopment && !isTest) {
      console.debug(...args);
    }
  },

  /**
   * Log d'information (toujours actif, même en production)
   * À utiliser uniquement pour les informations critiques
   */
  info: (...args: any[]) => {
    if (!isTest) {
      console.info(...args);
    }
  }
};
